module.exports = {"pt-BR":{"acknowledgment":{"thanks":"Obrigado!","message":"Em breve um de nossos especialistas entrará em contato com você!"}}}